// extracted by mini-css-extract-plugin
export default {"wrapper":"ticketLink_wrapper__Lp6aO","text":"ticketLink_text__hM7Rq","icon":"ticketLink_icon__P0WAX"};